import { useQuery, useMutation } from "@tanstack/react-query";
import { POST } from "../../../../../services/index";
import { message } from "antd";

export const UseFetchCreateInput = () => {
    return useMutation(async (payload) => {
      try {
        const endPoint = `/api/v1/importInput`;
        const result = await POST(endPoint, payload);
        message.success("Create Input Success..");
        return result;
      } catch (error) {
        await message.destroy();
        message.error(error.response.data.message);
      }
    });
  };